<form [formGroup]="pointForm">
  <div class="bg-blue-2 d-flex al-center sp-between p-4">
    <div>
      <div>
        <span class="text-white fw-extrabold fs-4">Asignar puntos Kaizen</span>
      </div>
      <div>
        <span class="text-white fs-6 fw-regular">Ingresa los montos y puntos obtenidos en este mes por el asesor</span>
      </div>
    </div>
    <div>
      <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
    </div>
  </div>
  <mat-dialog-content class="p-4 d-flex flex-column content-form gap">
    <div>
      <div class="mb-2">
        <span>Monto vendido</span>
      </div>
      <input type="text" formControlName="amount" placeholder="Ingrese el monto vendido" class="w-100 border rounded px-3" (keypress)="keypressNumbers($event)">
    </div>
    <div>
      <div class="mb-2">
        <span>Puntos Kaizen</span>
      </div>
      <input type="text" formControlName="points" placeholder="Ingrese los puntos Kaizen" class="w-100 border rounded px-3" (keypress)="keypressNumbers($event)">
    </div>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button class="bg-blue-2 w-100" (click)="savePoints()">
        <span class="fw-bold fs-5 text-white me-3">Guardar</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>